module.exports = __webpack_public_path__ + "static/img/104910.31c17e59.png";